import { bind } from "@/apis/gameJump";
import CryptoJS from "crypto-js";
import { sort_ASCII } from "@/libs/utils";

const state = {
  userInfo: {
    user_name: "",
    nickname: "",
    user_id: 0,
    tel_num: "",
    tel_status: 0, // 是否绑定手机 0未绑定 1已绑定
    access_token: "",
    apk_url: "",
    unionid: "",
  },
  appkey: "",
};

const mutations = {
  CHANGE_USERINFO(state, obj) {
    state = Object.assign(state, obj);
  },
  CLEAR_USERINFO(state) {
    state.userInfo = "";
  },
};

const actions = {
  async userBind({ state, commit }, data) {
    const obj = {
      code: data.code,
      tel_num: data.phone,
      password: CryptoJS.MD5(
        `${data.password}${CryptoJS.MD5(`${data.password}`)}`
      ).toString(),
      access_token: state.userInfo.access_token,
      user_id: state.userInfo.user_id,
      appkey: state.appkey,
    };
    const r = await bind(obj);
    if (r.ret === 1) {
      commit("CHANGE_USERINFO", {
        tel_num: data.phone,
        tel_status: 1,
      });
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
